(async () => {
  if (!customElements.get('related-products')) {
    const { default: Swiper } = await import('swiper');

    class RelatedProducts extends HTMLElement {
      constructor() {
        super();

        if (this.dataset) {

          this.swiperElement = this.querySelector('[data-swiper]');

          this.swiperOptions = {
            loop: false,
            autoplay: false,
            direction: 'horizontal',
            spaceBetween: 16,
          };

          // Check if we have extra options on the HTML
          if (
            this.swiperElement &&
            this.swiperElement.dataset &&
            this.swiperElement.dataset.options
          ) {
            const jsonOptions = JSON.parse(this.swiperElement.dataset.options);

            if (jsonOptions) {
              this.swiperOptions = {
                ...this.swiperOptions,
                ...jsonOptions,
              };
            }
          }

          this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

           
        }

      }
    }

    window.RelatedProducts = RelatedProducts;

    customElements.define('related-products', RelatedProducts);
  }
})();
